import axios from "axios";

import { getToken } from "./auth";

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api/bd`
  : "/api/bd";

function authHeaders(token) {
  // BD components historically pass the token as an explicit argument
  // (prop drilling). When `token` is omitted we fall back to localStorage.
  // If neither yields a token, return {} and let App.js's global axios 401
  // interceptor handle the logout flow.
  const t = token ?? getToken();
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
}

export async function listClients(token) {
  const res = await axios.get(`${API}/clients`, authHeaders(token));
  return res.data;
}

export async function getClient(token, clientId) {
  const res = await axios.get(`${API}/clients/${clientId}`, authHeaders(token));
  return res.data;
}

export async function composePlanche(token, clientId) {
  const res = await axios.post(
    `${API}/clients/${clientId}/compose-planche`,
    {},
    authHeaders(token),
  );
  return res.data;
}

export async function getConversation(token, clientId) {
  const res = await axios.get(`${API}/conversations/${clientId}`, authHeaders(token));
  return res.data;
}

export async function sendMessage(token, clientId, message) {
  const res = await axios.post(
    `${API}/conversations/${clientId}/message`,
    { message },
    authHeaders(token),
  );
  return res.data;
}

export async function getJob(token, clientId) {
  // Statut de la génération : { status: "idle"|"running"|"done"|"error", error?, reply? }
  const res = await axios.get(
    `${API}/conversations/${clientId}/job`,
    authHeaders(token),
  );
  return res.data;
}

export async function unvalidateChapter(token, chapterKey) {
  // chapterKey = `${clientId}-${chapterIndex}` (forme du path param du router)
  const res = await axios.post(
    `${API}/chapters/${chapterKey}/unvalidate`,
    {},
    authHeaders(token),
  );
  return res.data;
}

export function imageUrl(clientId, chapterIndex, versionId, _token) {
  return `${API}/chapters/${clientId}-${chapterIndex}/versions/${versionId}/image`;
}

export async function listClientPhotos(token, clientId) {
  const res = await axios.get(`${API}/clients/${clientId}/photos`, authHeaders(token));
  return res.data;
}

export async function uploadClientPhotos(token, clientId, files) {
  const form = new FormData();
  for (const f of files) form.append("files", f);
  const t = token ?? getToken();
  const res = await axios.post(
    `${API}/clients/${clientId}/photos`,
    form,
    {
      headers: {
        ...(t ? { Authorization: `Bearer ${t}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return res.data;
}

export async function deleteClientPhoto(token, clientId, filename) {
  const res = await axios.delete(
    `${API}/clients/${clientId}/photos/${encodeURIComponent(filename)}`,
    authHeaders(token),
  );
  return res.data;
}

export async function tagPhotoBracket(token, clientId, bracket, photoUrls) {
  const res = await axios.post(
    `${API}/clients/${clientId}/portrait-bracket/${bracket}`,
    { photo_urls: photoUrls },
    authHeaders(token),
  );
  return res.data;
}

export async function generateCalibrationPortrait(
  token,
  clientId,
  bracket,
  styleNote,
) {
  const res = await axios.post(
    `${API}/clients/${clientId}/calibration/${bracket}/generate`,
    { style_note: styleNote?.trim() || null },
    authHeaders(token),
  );
  return res.data;
}

export async function approveCalibrationPortrait(token, clientId, bracket) {
  const res = await axios.post(
    `${API}/clients/${clientId}/calibration/${bracket}/approve`,
    {},
    authHeaders(token),
  );
  return res.data;
}

export async function rejectCalibrationPortrait(token, clientId, bracket) {
  const res = await axios.post(
    `${API}/clients/${clientId}/calibration/${bracket}/reject`,
    {},
    authHeaders(token),
  );
  return res.data;
}

export function photoPublicUrl(clientId, filename) {
  const base = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  return `${base}/api/bd/clients/${clientId}/photos/${filename}`;
}
